import React from 'react';
import UsersContainer from '../../Containers/UsersContainer';

const Users = (props) => {
	return (
		<UsersContainer show="users"/>
	);
}
export default Users;